import type { FormFieldMapping } from '../../../types/fieldMapping';

/**
 * For view `each` rows: when a field declares `adapterProps.titleFrom`,
 * use that sibling row value as the ViewField label (production tax-rate pattern).
 */
export function applyTitleFrom(
  field: FormFieldMapping,
  rowValues: Record<string, unknown> | undefined,
): FormFieldMapping {
  const titleFrom = field.adapterProps?.titleFrom;
  if (typeof titleFrom !== 'string' || titleFrom.length === 0) return field;

  const raw = rowValues?.[titleFrom];
  if (raw == null || raw === '') return field;

  return {
    ...field,
    overrideLabel: String(raw),
  };
}
